

import { RoleModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { rolesStore } from '@/libs/roles/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import RoleDialog from '../components/RoleDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        RoleDialog
    }
})
export default class Roles extends Page {

    get headers() {
        return [
            { text: this.$i18n.t("roles.name"), value: "name", align: "left", sortable: false },
            { text: this.$i18n.t("roles.permissions"), value: "name", align: "left", sortable: false },
            { text: "", value: "id", align: "left", sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: RoleDialog;

    @Watch("itemsPerPage")
    itemsPerPageChanged (v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return rolesStore.useGetter(CrudGetter.Pending);
    }
    
    get roles (): RoleModel[] {
        return [...rolesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows (): number {
        return ({...rolesStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    mounted () {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load () {
        rolesStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<RoleModel>({ field: "name", index: 1, order: "asc" }, this.getFilters());
    }

    open (item: RoleModel) {
        this.dialog.open(item.id!);
    }

    createItemClick () {
        this.dialog.open(Guid.EmptyGuid());
    }

}
